"use strict";
// Copyright (c) 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoneBootstrapper = void 0;
class NoneBootstrapper {
    /**
     * Applies callback to bootstrapper stack.
     */
    applyModule(name, callback) {
    }
    /**
     * Return stack for current bootstrapper.
     */
    stack() {
        return [];
    }
}
exports.NoneBootstrapper = NoneBootstrapper;
